import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { connect } from 'react-redux';
import ShortId from 'shortid';
import { Button, Popup, Table, Icon } from 'semantic-ui-react';
import Link from 'redux-first-router-link';
import moment from 'moment';
import classNames from 'classnames';
import { DropdownOptionsType } from '../../../lib/proptypes/semantic';
import { selectControlsState } from '../../../store/reducers/tableControls';
import { selectWeeksForDropdown } from '../../../store/reducers/season';
import FiltersHeader from '../../components/FiltersHeader';
import FilterToggle from '../../components/FilterComponents/FilterToggle';
import TableControls from '../../components/TableControls';
import { DataPT } from '../../components/DataTable/DataTable.proptypes';
import PrimaryDropdown from '../../components/FilterComponents/PrimaryDropdown';
import { goToView } from '../../routes.global';
import { goPlayer } from '../Player/module/player';
// import { MATCHUP_ANALYSIS_VIEW } from './MatchupAnalysis/module/analysis';
import {
  PREDICTIONS_VIEW,
  selectPredictionsState,
} from './module/predictions';
import classes from './predictions.css';
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { gciPageView } from '../../../lib/analytics';

// const log = debug('huddle:app:views:Predictions');
const pageTitle = 'Game Predictions';

const colGroups = [
  { name: '', columns: ['FFPT', 'Rush', 'Catch', 'Pass'] },
];

const mapStateToProps = state => {
  const isLoggedIn = state.auth.loggedIn;

  const {
    year,
    formulaId,
    week,
    matchups,
    teams,
    hasLoaded,
    showProjections,
  } = selectPredictionsState(state);

  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);

  return {
    isLoggedIn,
    hasLoaded,
    selectedYear: year,
    selectedWeek: week,
    selectedProfile: formulaId,
    showProjections,
    matchups,
    teams,
    weeks: selectWeeksForDropdown(state, year, 'predictions'),
    collapsed: selectControlsState(state).collapsed,
    toolDescriptions,
    toolsLoaded,
  };
};
const actions = {
  goToView,
};
class Predictions extends PureComponent {
  static propTypes = {
    hasLoaded: PT.bool.isRequired,
    collapsed: PT.bool.isRequired,
    selectedYear: PT.number,
    selectedProfile: PT.number.isRequired,
    selectedWeek: PT.number,
    showProjections: PT.bool.isRequired,
    weeks: DropdownOptionsType,
    goToView: PT.func.isRequired,
    teams: PT.objectOf(DataPT).isRequired,
    matchups: PT.arrayOf(PT.shape({
      home_team_id: PT.number.isRequired,
      home_team_city: PT.string.isRequired,
      home_team_name: PT.string.isRequired,
      home_team_helmet: PT.string.isRequired,
      pred_home_score: PT.number.isRequired,
      away_team_id: PT.number.isRequired,
      away_team_city: PT.string.isRequired,
      away_team_name: PT.string.isRequired,
      away_team_helmet: PT.string.isRequired,
      pred_away_score: PT.number.isRequired,
      start_date: PT.string.isRequired,
      timezone: PT.string.isRequired,
      venue_name: PT.string.isRequired,
      pred_line: PT.string.isRequired,
      pred_ou: PT.string,
      home_team_stats: PT.arrayOf(PT.object.isRequired),
      away_team_stats: PT.arrayOf(PT.object.isRequired),
    })).isRequired,
    toolsLoaded: PT.bool.isRequired,
    gciPageView: PT.func.isRequired,
  }

  static defaultProps = {
    weeks: [],
  }

  handleChangeYear = (event, { value }) => {
    const { selectedYear, selectedProfile } = this.props;

    if (selectedYear !== value) {
      document.location = '/in-season/nfl-fantasy-football-game-predictions?year=' + value + '&formulaId=' + selectedProfile;
      // this.props.goToView(
      //   PREDICTIONS_VIEW,
      //   {
      //     query: { year: value, formulaId: selectedProfile },
      //     updateQuery: false,
      //   },
      // );
    }
  }

  handleChangeProfile = (event, { value }) => {
    if (this.props.selectedProfile !== value) {
      this.props.goToView(PREDICTIONS_VIEW, { query: { formulaId: value } });
    }
  }

  handleChangeWeek = (event, { value }) => {
    if (this.props.selectedWeek !== value) {
      this.props.goToView(PREDICTIONS_VIEW, { query: { week: value, year: this.props.selectedYear } });
    }
  }

  handleToggleProjections = () => {
    this.props.goToView(
      PREDICTIONS_VIEW,
      { query: { showProjections: !this.props.showProjections } },
    );
  }

  renderTeam = team => {
    const wrapperClass = classNames(
      classes.tableWrapper,
      { [classes.collapsed]: this.props.collapsed },
    );

    return (
      <div className={wrapperClass}>
        <Table unstackable celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="2">
                {team[0].team_abbr} {team[0].opponent_location} {team[0].opponent_team_abbr}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                <Popup
                  trigger={<span>FFPT</span>}
                  position="top center"
                  content="Total Fantasy Points (Calculated)"
                  wide
                  className={classes.statPopup}
                />
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                <Popup
                  trigger={<span>Rush</span>}
                  position="top center"
                  content="Projected rushing stats (yardage,touchdowns)"
                  wide
                  className={classes.statPopup}
                />
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                <Popup
                  trigger={<span>Catch</span>}
                  position="top center"
                  content="Projected receiving stats (catches-yardage,touchdowns)"
                  wide
                  className={classes.statPopup}
                />
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                <Popup
                  trigger={<span>Pass</span>}
                  position="top center"
                  content="Projected passing stats (yardage,touchdowns)"
                  wide
                  className={classes.statPopup}
                />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {team.map(player => this.renderPlayerRow(player))}
          </Table.Body>
        </Table>
      </div>
    );
  }

  renderPlayerRow = ({
    player_id: playerId,
    fpts,
    fname,
    lname,
    position,
    stats,
  }) => {
    const name = `${fname} ${lname}`;

    const calcFirstName = (fname, lname) => {

       let displayFirstName = fname;
       if (fname.length + lname.length > 16) {
        displayFirstName = fname.toString().substring(0,1) + '.';
       }
       return displayFirstName;
    };

    const defineStat = statId => {
      const statIdArray = stats.filter(individualStat => individualStat.stat === statId);

      let statValue;

      if (statIdArray.length > 0) {
        statValue = statIdArray[0].stat_value_total;
      } else {
        statValue = 0;
      }

      return statValue;
    };

    const passingYards = defineStat('pa_yd');
    const passingTDs = defineStat('pa_td');
    const rushingYards = defineStat('ru_yd');
    const rushingTDs = defineStat('ru_td');
    const receptions = defineStat('rec');
    const receivingYards = defineStat('re_yd');
    const receivingTDs = defineStat('re_td');
    const fieldGoalsMade = defineStat('fgm');
    const extraPointsMade = defineStat('xpm');

    return (
      <Table.Row key={ShortId.generate()}>
        <Table.Cell textAlign="center">{position}</Table.Cell>
        <Table.Cell singleLine className={classes.playerCell}>
              <Link
                to={goPlayer(playerId, `${fname}-${lname}`)}
                className={classes.playerName}
              >
              <div className={classes.nameIndi}>
                <span className={classes.nameAlign}>{calcFirstName(fname, lname)}&nbsp;</span>
                <div className={classes.nameIndi2}>
                  <span className={classes.nameAlign}>{lname}</span>
                </div>
              </div>
              </Link>

        </Table.Cell>
        <Table.Cell textAlign="center">{fpts}</Table.Cell>
        {position === 'PK'
          ? (<Table.Cell textAlign="center">
            {fieldGoalsMade > 0
              ? (<span>{fieldGoalsMade}FG</span>)
              : '-'
            }
          </Table.Cell>)
          : (<Table.Cell textAlign="center">
            {rushingYards > 0 || rushingTDs > 0
                 ? (<span>{rushingYards},{rushingTDs}</span>)
                 : '-'
               }
          </Table.Cell>)
        }
        {position === 'PK'
          ? (<Table.Cell textAlign="center">
            {extraPointsMade > 0
              ? (<span>{extraPointsMade}XP</span>)
              : '-'
            }
          </Table.Cell>)
          : (<Table.Cell textAlign="center">
            {receptions > 0 || receivingTDs > 0
              ? (<span>{receptions}-{receivingYards},{receivingTDs}</span>)
              : '-'
            }
          </Table.Cell>)
        }
        <Table.Cell textAlign="center">
          {passingYards > 0 || passingTDs > 0
            ? (<span>{passingYards},{passingTDs}</span>)
            : '-'
          }
        </Table.Cell>
      </Table.Row>
    );
  }


  renderPrediction = ({
    game_id: gameId,
    home_team_id: homeId,
    away_team_id: awayId,
    home_team_city: homeCity,
    home_team_name: homeName,
    home_team_helmet: homeHelmetImg,
    away_team_city: awayCity,
    away_team_name: awayName,
    away_team_helmet: awayHelmetImg,
    start_date: startDate,
    timezone: timeZone,
    venue_name: venue,
    pred_home_score: homeScore,
    pred_away_score: awayScore,
    pred_line: line,
    pred_ou: ou,
    home_team_stats: homeStats,
    away_team_stats: awayStats,
  }, disableToggle) => (
    <div
      key={ShortId.generate()}
      className={classes.predictionWrapper + (this.props.showProjections ? " " + classes.predictionBackground : "")}
      style={{ ...this.props.showProjections && !disableToggle && { flex: 1 } }}
    >
      {this.props.showProjections && !disableToggle && this.renderTeam(awayStats)}

      <div className={classes.matchupWrapper}>
        <h3 className={classes.teams}>
          {awayCity} {awayName}
          <br />
          @
          <br />
          {homeCity} {homeName}
        </h3>

        <div className={classes.subText}>
          {startDate ? moment(startDate).format('dddd, MMM Do YYYY h:mm a') : "Date and time unavailable"} {startDate ? timeZone : ""}
          <br />
          {venue}
        </div>

        <div className={classes.scoresWrapper}>
          <div className={classes.awayHelmet}>
            <img src={awayHelmetImg} alt={`${awayCity} ${awayName} Helmet`} />
          </div>
          <div className={classes.predictionTextWrapper}>
            <div className={classes.scores}>
              {awayScore}
              <span className={classes.pointer}>
                <span className={homeScore < awayScore ? classes.pointLeft : classes.pointRight} />
              </span>
              {homeScore}
            </div>
            <div className={classes.prediction}>PREDICTION</div>
          </div>
          <div className={classes.homeHelmet}>
            <img src={homeHelmetImg} alt={`${homeCity} ${homeName} Helmet`} />
          </div>
        </div>
        {
          ou === undefined | ou===null | ou===''?
            <div className={classes.lineou}>Line: {`${line}`}</div>
            : <div className={classes.lineou}>Line: {`${line}, O/U = ${ou}`}</div>
        }
        <div>
          <Link to={`/in-season/predictions/analysis/${gameId}/${this.props.selectedProfile}`}>
            <Button className={classes.button} data-match={gameId}>MATCHUP ANALYSIS</Button>
          </Link>
        </div>
      </div>

      {this.props.showProjections && !disableToggle && this.renderTeam(homeStats)}
    </div>
  )

  render() {
    const {
      isLoggedIn,
      weeks,
      selectedYear,
      selectedProfile,
      selectedWeek,
      hasLoaded,
      matchups,
      showProjections,
      toolDescriptions,
      toolsLoaded,
    } = this.props;

    const disableToggle = (hasLoaded && matchups.length > 0) ? !(matchups[0].home_team_stats.length > 0) : true;

    return (
      <div className={classes.wrapper}>
        <FiltersHeader
          title={pageTitle}
          description={toolsLoaded && toolDescriptions.tool_descriptions.game_predictions.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.game_predictions.text}
            />)}
          seasonType="seasons"
          statType="predictions"
          selectedYear={selectedYear}
          selectedProfile={selectedProfile}
          onChangeProfile={this.handleChangeProfile}
          onChangeYear={this.handleChangeYear}
        >
          <div className={classes.filterWrapper}>
            <PrimaryDropdown
              choices={weeks}
              label="Week:"
              activeItem={selectedWeek}
              onChange={this.handleChangeWeek}
            />
            <div className={classes.projectionsToggle}>
              <FilterToggle
                checked={disableToggle ? false : showProjections}
                disabled={disableToggle}
                onChange={this.handleToggleProjections}
                valueOff={'NO'}
                valueOn={'YES'}
                label={'Show team projections:'}
              />
            </div>
          </div>
        </FiltersHeader>

            {hasLoaded && showProjections && !disableToggle &&
              <div>
                <TableControls colGroups={colGroups} />
              </div>
            }
            {hasLoaded
              ?
                <div>
                  <div
                  className={classes.matchupsWrapper}
                  style={{ ...!(showProjections && !disableToggle) && { flexDirection: 'row' } }}
                  >
                    {matchups.length > 0 && matchups.map(matchup => this.renderPrediction(matchup, disableToggle))}
                    {isLoggedIn && matchups.length < 1 && <div><h3>No data available for this period.</h3></div>}
                  </div>
                  {!isLoggedIn && <div><h3> Please Log In or Subscribe to Access This Data.</h3></div>}
                </div>
              : ' '
            }
      </div>
    );
  }

  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
  }

  componentDidUpdate() {
    let cgm = document.getElementById('contentGateMask');
    if( cgm != null ) {
      cgm.style.visibility = 'visible';
    }
  }
}
export default connect(mapStateToProps, actions)(Predictions);



// WEBPACK FOOTER //
// ./src/app/views/Predictions/Predictions.js